import * as yup from 'yup';

export interface FuncionarioMin {
  cpf: string;
  valor: number;
  nome?: string;
  saldo?: number;
}
export interface Transferencias {
  funcionarios: FuncionarioMin[];
}

export const TRANSFERENCIA_DEFAULT: Transferencias = {
  funcionarios: []
};

export const VALOR_MAXIMO_TRANSFERENCIA = 100000;

const MSG_REQUIRED = 'Campo obrigatório';
const MIN_ZERO = 'Valor deve ser maior que 0';
const MIN_SALDO = 'Valor deve ser menor que o saldo disponível do usuário';
const MAX_VALOR = 'Valor máximo permitido: R$ 100.000,00';
const MAX_TOTAL = 'O total deve ser de até R$ 100.000,00';

export const enviarTransferenciaFormModelSchema: yup.ObjectSchema<Transferencias> = yup
  .object()
  .shape({
    funcionarios: yup
      .array()
      .of(
        yup.object<FuncionarioMin>().shape({
          cpf: yup.string().required(MSG_REQUIRED),
          valor: yup
            .number()
            .max(VALOR_MAXIMO_TRANSFERENCIA, MAX_VALOR)
            .test('saldo', MIN_ZERO, (val) => val !== undefined && val > 0)
            .required(MSG_REQUIRED),
          nome: yup.string().optional(),
          saldo: yup.number().optional()
        })
      )
      .test(
        'limite-total',
        MAX_TOTAL,
        (usuarios) =>
          (usuarios?.reduce((total, usuario) => total + (usuario.valor || 0), 0) ?? 0) <=
          VALOR_MAXIMO_TRANSFERENCIA
      )
      .required(MSG_REQUIRED)
  });

export const estornarTransferenciaFormModelSchema: yup.ObjectSchema<Transferencias> = yup
  .object()
  .shape({
    funcionarios: yup
      .array()
      .of(
        yup.object().shape({
          cpf: yup.string().required(MSG_REQUIRED),
          valor: yup
            .number()
            .when('saldo', ([saldo], schema) => schema.max(saldo, MIN_SALDO))
            .test(
              'limite-valor',
              MAX_VALOR,
              (val) => val === undefined || val <= VALOR_MAXIMO_TRANSFERENCIA
            )
            .test('valor', MIN_ZERO, (val) => val !== undefined && val > 0)
            .required(MSG_REQUIRED),
          nome: yup.string().optional(),
          saldo: yup.number().optional()
        })
      )
      .test(
        'limite-total',
        MAX_TOTAL,
        (usuarios) =>
          (usuarios?.reduce((total, usuario) => total + (usuario.valor || 0), 0) ?? 0) <=
          VALOR_MAXIMO_TRANSFERENCIA
      )
      .required(MSG_REQUIRED)
  });
